import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { resolve } from 'inversify-react';

import { ControllerProps } from 'src/router';
import { InvoiceList } from 'src/app/accounting/shared/invoices/list/invoice-list';
import { InvoiceListDataService } from 'src/app/accounting/shared/invoices/list/invoice-list.data';
import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';

interface Props extends ControllerProps<{}> {
}

@observer
export class ClientInvoiceList extends React.Component<Props, {}> {
	@resolve
	private toast: ToastNotifications;

	@observable
	private dataService: InvoiceListDataService;

	constructor(props: Readonly<Props>) {
		super(props);
	}

	componentDidMount(): void {
		const { setBusy } = this.props;

		setBusy(true);
		this.loadData()
			.catch((error) => {
				this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
			})
			.then(() => {
				this.props.setBusy(false);
			});
	}

	private async loadData(): Promise<void> {
		this.dataService = InvoiceListDataService.make();

		this.dataService.addFilter('accountingTarget', 'eq', 1);
		this.dataService.addFilter('isDeleted', 'eq', false);
		this.dataService.addSorting('id', 'asc');
		this.dataService.pageSize = 1000;

		await this.dataService.load(query => query);
	}

	render(): React.ReactNode {
		if (this.dataService == null || this.dataService.items == null) {
			return null;
		}

		const { setBusy } = this.props;

		return (
			<div className="window window-normal">
				<div className="panel">
					<InvoiceList
						isManagementMode
						model={this.dataService}
						setBusy={setBusy}
					/>
				</div>
			</div>
		);
	}
}




// WEBPACK FOOTER //
// ./src/app/accounting/clients/client-invoice-list.tsx